import React,{ useState, useEffect} from 'react'
import { Col } from 'react-bootstrap';
import { Container,Row } from 'react-bootstrap';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import api from '../../../interceptor/axios';
import { useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Form } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import {descargarPDF} from '../../../utils/descargarPDF';

const Escritorio =({})=>{
    const history = useHistory();   
    const [loading, setLoading] = useState(true);
    const toast = useRef(null);
    const [nick, setNick] = useState('');
    const [nuevoNick, setNuevoNick] = useState('');
    const [mostrarModalNick, setMostrarModalNick] = useState(false);
    const [testsGuardados, setTestsGuardados] = useState([]);
    const [ultimosDisponibles, setUltimosDisponibles] = useState([]);
    const restUrlBase = process.env.REACT_APP_REST_URL;

    useEffect(() => {
        api.post(process.env.REACT_APP_REST_URL + 'escritorio.php', {})
            .then(response => {
                if (response.data.success !== true) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: response.data.message });
                } else {
                    setNick(response.data.nick);
                    setTestsGuardados(response.data.testsGuardados);
                    setUltimosDisponibles(response.data.ultimosDisponibles);
                    //de los test guardados, el detalle lo pasamos a JSON
                    for(let i = 0; i < response.data.testsGuardados.length; i++){
                        response.data.testsGuardados[i].detalle = JSON.parse(response.data.testsGuardados[i].detalle);
                    }
                    setLoading(false);
                }
            })
            .catch(error => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se ha producido un error en la llamada al servidor' });
            });
    }, []); // <--- El array vacío asegura que esto solo se ejecuta una vez al montar el componente

    const abrirModalNick = () => {
        setNuevoNick(nick);
        setMostrarModalNick(true);
    }

    const actualizarNick = () => {

        if(nuevoNick === ''){
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Por favor, introduce un nick' });
            return;
        }

        if(nuevoNick.trim().length < 3 || nuevoNick.length > 20){
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'El nick debe tener entre 3 y 20 caracteres' });
            return;
        }

        if(nuevoNick === nick){
            toast.current.show({ severity: 'info', summary: 'Aviso', detail: 'El nick no ha cambiado' });
            setMostrarModalNick(false);
            return;
        }

        api.post(process.env.REACT_APP_REST_URL + 'actualizarNick.php', {nuevoNick: nuevoNick})
            .then(response => {
                if (response.data.success !== true) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: response.data.message });
                } else {
                    setMostrarModalNick(false);
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: response.data.message });
                }
            })
            .catch(error => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se ha producido un error en la llamada al servidor' });
            });
    }

    const irARecurso = (recurso) => {
        console.log("Recurso seleccionado: ", recurso);
        if(recurso.tipo === 'leccion'){
            irALeccion(recurso);
        } else if(recurso.tipo === 'test'){
            hacerTest(recurso);
        } else {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Tipo de recurso no reconocido' });
        }
    };

    const irALeccion = (leccion) => {
      sessionStorage.setItem('idLeccion',leccion.ID);
      history.push('/leccion');
    };

    const hacerTest = (test) => {
      setLoading(true);
      api.post(process.env.REACT_APP_REST_URL + "test/test.php", { idTest : test.ID  })
      .then(response => {
          setLoading(false);

          if(response.data.auth !== true){
            toast.current.show({ severity: 'error', summary: 'Error', detail: response.data.message });
            sessionStorage.clear();
            setTimeout(() => {
                history.replace('/login');
            }, 5000);

        } else {
            if (response.data.success) {
                //para cada pregunta, añadimos un campo nuevo
                response.data.test.preguntas.forEach(pregunta => {
                    pregunta.respuestaSeleccionada = 0;
                });
                response.data.test.fechaInicio = new Date().getTime();
                response.data.test.metodoCorreccion = response.data.test.metodo_correccion;
                sessionStorage.setItem('test', JSON.stringify(response.data.test));
                history.push('/test');
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: response.data.message });
            }
        }
          
      })
      .catch(error => {
          setLoading(false);
          toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se ha producido un error en la llamada al servidor' });
      });        
    };

    const hacer = (test) => {
        setLoading(true);
        api.post(restUrlBase + "test/testGuardado.php", { idTest : test.ID })
        .then(response => {
            if (response.data.success) {
                test.fechaInicio = new Date().getTime();
                sessionStorage.setItem('test', JSON.stringify(response.data.test));
                history.push('/test');
            } else {
                setLoading(false);
                toast.current.show({ severity: 'error', summary: 'Error', detail: response.data.message });
            }
        })
        .catch(error => {
            setLoading(false);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se ha producido un error en la llamada al servidor' });
        });        
      };

      const formatearFecha = (fechaStr, soloFecha = false) => {
        const fecha = new Date(fechaStr);
        const pad = (n) => n.toString().padStart(2, '0');

        const dia = pad(fecha.getDate());
        const mes = pad(fecha.getMonth() + 1); // Los meses van de 0 a 11
        const año = fecha.getFullYear();
        const horas = pad(fecha.getHours());
        const minutos = pad(fecha.getMinutes());
        const segundos = pad(fecha.getSeconds());

        if (soloFecha) {
            return `${dia}/${mes}/${año}`;
        }

        return `${dia}/${mes}/${año} ${horas}:${minutos}:${segundos}`;
    };

    const esRecursoOnline = (recurso) =>
        recurso.tipo === 'leccion' ||
        (recurso.tipo === 'test' && Number(recurso.online) === 1);

    const esRecursoDescargable = (recurso) =>
        recurso.tipo === 'test' && Number(recurso.descargable) === 1;

    const descargarTest = async (test) => {
        try{
            await descargarPDF('T', test.ID, test.nombre + '.pdf');
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se ha producido un error al descargar el test' });
        }
    };

    if(loading){

        return (
            <>
            <Toast ref={toast} />
            <div className="main-content">
                <Container fluid>
                    <Row>
                        <Col xs="12" lg="4" className="overflow-hidden">
                            <div className="d-flex flex-column">
                                <Skeleton width="100%" height="50px" />
                                <Skeleton width="100%" height="50px" />
                                <Skeleton width="100%" height="50px" />
                            </div>
                        </Col>
                        <Col xs="12" lg="8" className="overflow-hidden">
                            <div className="d-flex align-items-center justify-content-between">
                                <Skeleton width="100%" height="50px" />
                            </div>
                            <div className="d-flex align-items-center justify-content-between">
                                <Skeleton width="100%" height="50px" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            </>
        );

    } else {

        return (
            <>
                <Toast ref={toast} />
                <Dialog header="Cambiar nick" visible={mostrarModalNick} onHide={() => setMostrarModalNick(false)} >
                    <div className='row d-flex flex-column text-center p-4'>
                        <div className='col-12'>
                            <p>La información se actualizará al momento, pero en tu sesión no se actualizará hasta que cierres sesión y vuelvas a entrar.</p>
                            <Form className="mt-4">
                                <Form.Group>                                 
                                    <Form.Control value={nuevoNick} onChange={(e) => setNuevoNick(e.target.value)} type="text" className="form-control mb-0" id="dni" placeholder="Introduce tu nuevo nick" autoComplete="off" required/>
                                </Form.Group>
                                <Button className="btn btn-hover btn-primary1" onClick={() => actualizarNick()}>Cambiar</Button>
                            </Form>
                        </div>
                    </div>
                </Dialog>
                <div className="main-content">
                    <Container fluid>
                        <Row>
                            <Col xs="12" lg="4" className="overflow-hidden">
                                <div className="bloque-ranking">
                                    <h4>Mi posición en el ranking</h4>

                                    <p className="texto-ranking">
                                        Próximamente estarán disponibles las ligas y competiciones
                                        de la academia. En ellas, se harán test controlados por
                                        nota, tiempo, preguntas acertadas, falladas y en blanco
                                        para determinar un ránking de alumnos.
                                    </p>

                                    <p className="texto-ranking">
                                        Se implementará un sistema de divisiones, de manera que
                                        podrás ascender o descender de división en función de la
                                        posición que tengas al final de cada temporada.
                                    </p>

                                    <p className="texto-ranking">
                                        Como identificación del alumno, se usará un nickname.
                                        Actualmente, tu nick es <strong>{nick}</strong>
                                    </p>

                                    <button
                                        className="btn btn-primary w-100"
                                        onClick={() => abrirModalNick()}>
                                        Cambiar nick
                                    </button>
                                 </div>
                            </Col>
                            <Col xs="12" lg="8" className="overflow-hidden">
                                {/* ÚLTIMAS SUBIDAS DISPONIBLES */}
                                <div className="seccion-escritorio">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <h5 className="titulo-seccion-escritorio">
                                            Últimas subidas disponibles
                                        </h5>
                                    </div>

                                    {/* Tabla escritorio */}
                                    <div className="table-view tabla-escritorio">
                                        <table
                                            className="data-tables table tabla-compacta"
                                            style={{ width: "100%" }}
                                        >
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "70%" }}>Nombre</th>
                                                    <th style={{ width: "20%" }}>Fecha</th>
                                                    <th className="col-accion"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {ultimosDisponibles.map((recurso, indexRecurso) => (
                                                    <tr key={indexRecurso}>
                                                        <td>
                                                            <span
                                                                className={`badge-recurso ${
                                                                    recurso.tipo === "leccion"
                                                                        ? "leccion"
                                                                        : recurso.tipo === "test"
                                                                        ? "test"
                                                                        : "otro"
                                                                }`}
                                                            >
                                                                {recurso.tipo === "leccion"
                                                                    ? "LECCIÓN"
                                                                    : recurso.tipo === "test"
                                                                    ? "TEST"
                                                                    : recurso.tipo?.toUpperCase()}
                                                            </span>

                                                            {recurso.nombre}
                                                        </td>

                                                        <td>{formatearFecha(recurso.fecha, true)}</td>

                                                        <td className="col-accion">
                                                            {esRecursoOnline(recurso) ? (
                                                            <button
                                                                type="button"
                                                                className="btn btn-hover iq-button btn-tabla-accion"
                                                                onClick={() => irARecurso(recurso)}
                                                            >
                                                                <i
                                                                    className="fa fa-cog"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </button>
                                                            ) : ( null)}
                                                            {esRecursoDescargable(recurso) ? (
                                                            <button
                                                                type="button"
                                                                className="btn btn-hover iq-button btn-tabla-accion"
                                                                onClick={() => descargarTest(recurso)}
                                                            >
                                                                <i
                                                                    className="fa fa-download"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </button>
                                                            ) : ( null)}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Cards móvil */}
                                    <div className="lista-movil">
                                        {ultimosDisponibles.map((recurso, indexRecurso) => (
                                            <div
                                                className="card-listado-movil"
                                                key={indexRecurso}
                                            >
                                                <div className="fila-superior">
                                                    <p className="titulo mb-0">
                                                        <span
                                                            className={`badge-recurso ${
                                                                recurso.tipo === "leccion"
                                                                    ? "leccion"
                                                                    : recurso.tipo === "test"
                                                                    ? "test"
                                                                    : "otro"
                                                            }`}
                                                        >
                                                            {recurso.tipo === "leccion"
                                                                ? "LECCIÓN"
                                                                : recurso.tipo === "test"
                                                                ? "TEST"
                                                                : recurso.tipo?.toUpperCase()}
                                                        </span>

                                                        {recurso.nombre}
                                                    </p>
                                                </div>

                                                <div className="meta">
                                                    {formatearFecha(recurso.fecha, true)}
                                                </div>

                                                <div className="acciones">
                                                    
                                                    {esRecursoOnline(recurso) ? (
                                                        <button
                                                            type="button"
                                                            className="btn btn-hover iq-button"
                                                            onClick={() => irARecurso(recurso)}>
                                                            <i
                                                                className="fa fa-cog mr-1"
                                                                aria-hidden="true"
                                                            ></i>
                                                            Abrir
                                                        </button>
                                                        ) : ( null)
                                                    }
                                                    {esRecursoDescargable(recurso) ? (
                                                        <button
                                                            type="button"
                                                            className="btn btn-hover iq-button"
                                                            onClick={() => descargarTest(recurso)}>
                                                            <i
                                                                className="fa fa-download"
                                                                aria-hidden="true"
                                                            ></i>
                                                            Descargar
                                                        </button>
                                                        ) : ( null)
                                                    }

                                                    
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* ÚLTIMOS TEST REALIZADOS */}
                                <div className="seccion-escritorio">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <h5 className="titulo-seccion-escritorio">
                                            Últimos test realizados
                                        </h5>
                                    </div>

                                    {/* Tabla escritorio */}
                                    <div className="table-view tabla-escritorio">
                                        <table
                                            className="data-tables table tabla-compacta"
                                            style={{ width: "100%" }}
                                        >
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "55%" }}>Test</th>
                                                    <th style={{ width: "20%" }}>Fecha</th>
                                                    <th style={{ width: "10%" }}>Nota</th>
                                                    <th className="col-accion"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {testsGuardados.map((test, indexTest) => (
                                                    <tr key={indexTest}>
                                                        <td>{test.descripcion}</td>
                                                        <td>{formatearFecha(test.fecha, true)}</td>
                                                        <td>{test.detalle?.nota}</td>
                                                        <td className="col-accion">
                                                            <button
                                                                type="button"
                                                                className="btn btn-hover iq-button btn-tabla-accion"
                                                                onClick={() => hacer(test)}
                                                            >
                                                                <i
                                                                    className="fa fa-cog"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Cards móvil */}
                                    <div className="lista-movil">
                                        {testsGuardados.map((test, indexTest) => (
                                            <div
                                                className="card-listado-movil"
                                                key={indexTest}
                                            >
                                                <div className="fila-superior">
                                                    <p className="titulo mb-0">
                                                        {test.descripcion}
                                                    </p>
                                                </div>

                                                <div className="meta">
                                                    <div>
                                                        <strong>Fecha:</strong>{" "}
                                                        {formatearFecha(test.fecha, true)}
                                                    </div>
                                                    <div>
                                                        <strong>Nota:</strong>{" "}
                                                        {test.detalle?.nota}
                                                    </div>
                                                </div>

                                                <div className="acciones">
                                                    <button
                                                        type="button"
                                                        className="btn btn-hover iq-button"
                                                        onClick={() => hacer(test)}
                                                    >
                                                        <i
                                                            className="fa fa-cog mr-1"
                                                            aria-hidden="true"
                                                        ></i>
                                                        Reanudar
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        );
    }
}

export default Escritorio;
